import React, { useEffect, useState } from 'react'
import { Box, Grid } from '@mui/material'
import { useSelector } from 'react-redux'
import HeaderContainer from '../common/Header/HeaderContainer'
import SimpleSnackbar from 'components/common/SnackBar'
import LoadingView from './LoadingView'
import SideBar from '../common/Header/Sidebar'
import appActions from './actions'
import PropTypes from 'prop-types'
import useStyles from './Styles'
import settingsActions from 'pages/settings/actions'
import InviteUserDialog from 'pages/User/CreateUser/InviteUserDialog'
import Forbidden403 from 'components/ErrorPages/403'

export const checkProtected = (isProtected, loggedIn, role, checkRoles) => {
    const logincheck = isProtected ? loggedIn : true
    const roleCheck = checkRoles.length > 0 ? checkRoles.includes(role) : true
    return logincheck && roleCheck
}

const App = ({
    children,
    isProtected = false,
    checkRoles = [],
    showHeader = true,
    showSideBar = true,
    isSevenScreen = false,
}) => {
    const { busy, toast } = useSelector((state) => state.app)
    const { loggedIn, role } = useSelector((state) => state.auth)

    const { message, type } = toast
    const classes = useStyles()
    const { removeToastMessage } = appActions()
    const [hasAccess, setHasAccess] = useState(false)

    useEffect(() => {
        if (checkRoles.length > 0) {
            setHasAccess(checkRoles.includes(role))
        } else {
            setHasAccess(true)
        }
    }, [role, checkRoles])


    return (
        <div className={classes.root}>
            {!isSevenScreen && showHeader && <HeaderContainer />}
            {showSideBar && showHeader && loggedIn && <SideBar />}

            {checkProtected(isProtected, loggedIn, role, checkRoles) && (
                <Grid className={classes.pageContent}>
                    {showHeader && !isSevenScreen && (
                        <>
                            <div className={classes.toolbar} />
                            <Box height="1px">
                                <LoadingView currentlySending={busy} />
                            </Box>
                        </>
                    )}
                    {children}
                </Grid>
            )}

            {!checkProtected(isProtected, loggedIn, role, checkRoles) && <Forbidden403 />}

            {message && (
                <SimpleSnackbar
                    clearMessage={removeToastMessage}
                    message={message}
                    type={type}
                />
            )}
            <InviteUserDialog />
        </div>
    )
}

App.propTypes = {
    checkRoles: PropTypes.arrayOf(PropTypes.string.isRequired),
    children: PropTypes.node.isRequired,
    isProtected: PropTypes.bool,
    showHeader: PropTypes.bool,
}

App.defaultProps = {
    checkRoles: [],
    isProtected: false,
    showHeader: true,
}

export default App
